var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component-in-worker',{scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('i',{staticClass:"el-icon-takeaway-box"})]},proxy:true}])},[_c('h2',[_vm._v("No Data")])])
}
var staticRenderFns = []

export { render, staticRenderFns }